<template>
	<div class="game-nav no-scrollbar" v-if="items">
		<component class="game-nav__item"
			 	v-for="item in items"
				:is="item.disabled ? 'button' : 'router-link'"
				:to="{name: item.link}"
				:disabled="item.disabled"
			 	:class="[$route.name === item.link ? 'active' : '']"
			>
			<svg class="game-nav__item-icon">
				<use :href="`#svg-icon-${item.icon}`"></use>
			</svg>
			<span class="game-nav__item-name">{{item.text}}</span>
		</component>
	</div>
</template>

<script>

export default {
	data() {
		return {
			items: [
				{
					text: 'Dice',
					icon: 'dice',
					link: 'dice'
				},
				{
					text: 'Mines',
					icon: 'mines',
					link: 'mines'
				},
				{
					text: 'Slots',
					icon: 'slots',
					link: 'slots'
				},
				{
					text: 'Live',
					icon: 'live',
					link: 'live'
				},
				{
					text: 'Coin',
					icon: 'coin',
					link: 'coinflip'
				},
				{
					text: 'Wheel',
					icon: 'wheel',
					link: 'wheel',
					disabled: true
				},
				{
					text: 'Crash',
					icon: 'crash',
					link: 'crash',
					disabled: true
				}
			]
		}
	}
}

</script>